import { FC } from 'react'
import s from './SectionTitle.module.sass'
import { Title } from '@shared/ui/Typography/Title'
import { ButtonLinkMore } from '@shared/ui/Actions/ButtonLinkMore'
import Link from '@shared/ui/Navigation/Link'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { PickAnalytic } from '@shared/api/analytics/types/types'
import { SectionTitleSkeleton } from '@shared/ui/Layout/SectionTitle/index'
import { TypesTagTitle } from '@shared/ui/Typography/Title/Title'

interface Props {
  title?: string
  tagTitle?: TypesTagTitle
  link?: string | object
  handleBeforeAction?: () => boolean
  skeleton?: boolean
  className?: string

  analytic?: PickAnalytic<'section_name'>
  titleComponent?: React.ReactElement
}

const SectionTitle: FC<Props> = ({
  title,
  link,
  tagTitle = 'h2',
  handleBeforeAction,
  className,
  analytic,
  skeleton,
  titleComponent,
  ...props
}) => {
  const Header = () => {
    return (
      <>
        {titleComponent || (
          <Title tag={tagTitle} sizes='h2 h2 h2 h4' className={s.title}>
            {title}
          </Title>
        )}
      </>
    )
  }

  if (skeleton) return <SectionTitleSkeleton />

  return (
    <BlockBoundary>
      <div className={`${s.wrapper} ${className} section-title`} {...props}>
        {link ? (
          <Link href={link} className={s['title-link']} scroll={false}>
            <Header />
          </Link>
        ) : (
          <Header />
        )}

        {link && (
          <ButtonLinkMore
            link={link}
            handleBeforeAction={handleBeforeAction}
            analytic={{ section_name: analytic?.section_name || title }}
            className={`${s.button} title-button-link`}
          />
        )}
      </div>
    </BlockBoundary>
  )
}

export default SectionTitle
